import { render, staticRenderFns } from "./CommentChat.vue?vue&type=template&id=257547c2&scoped=true"
import script from "./CommentChat.js?vue&type=script&lang=js&external"
export * from "./CommentChat.js?vue&type=script&lang=js&external"
import style0 from "./CommentChat.vue?vue&type=style&index=0&id=257547c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257547c2",
  null
  
)

export default component.exports